import "../index.scss";

import React from "react";

class Picture extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            avatar: null
        }

        this.fileRef = React.createRef();

        _.map(["onClick", "onChange"], fn => {
            this[fn] = this[fn].bind(this);
        });
    }

    onClick(e) {
        e.preventDefault();

        if( this.fileRef.current ) {
            this.fileRef.current.click();
        }
    }

    onChange(e) {
        if(this.props.onChange) {
            const file = e.target.files[0];

            this.setState({ ...this.state, avatar: URL.createObjectURL(file) }, () => {
                this.props.onChange(file);
            });
        }
    }

    render() {
        return (
            <div class="pictureUploader">
                <a href="/" onClick={ this.onClick }>
                    { (this.state.avatar || this.props.avatar) && (
                        <div class="image-holder" style={{ backgroundImage: `url(${ this.state.avatar ? this.state.avatar : this.props.avatar })`, maxWidth: 100, width: "100%", height: 100 }}></div>
                    )}
                    <span>Click here to upload</span>
                </a>
                <input ref={ this.fileRef } type="file" accept=".png, .jpg, .jpeg, .gif, .svg" style={{ display: "none" }} onChange={ this.onChange } />
            </div>
        );
    }
}

export default Picture;